<template>
  <span
    :class="[
      inline ? 'doodle-inline' : 'doodle',
      motionClass,
      hideOnMobile ? 'doodle-desktop-only' : '',
    ]"
    :style="positionStyle"
    aria-hidden="true"
  >
    <!-- Star -->
    <svg v-if="type === 'star'" :width="size" :height="size" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2.5l1.6 6.2L20 10l-5.2 3.1L16.5 20 12 16.2 7.5 20l1.7-6.9L4 10l6.4-1.3L12 2.5z"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linejoin="round"
        fill="none"
      />
    </svg>

    <!-- Sparkle -->
    <svg v-else-if="type === 'spark'" :width="size" :height="size" viewBox="0 0 24 24" fill="none">
      <path d="M12 3v18M3 12h18M6.5 6.5l11 11M17.5 6.5l-11 11" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    </svg>

    <!-- Heart -->
    <svg v-else-if="type === 'heart'" :width="size" :height="size" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 20s-7-4.4-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.6-7 10-7 10z"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linejoin="round"
        fill="none"
      />
    </svg>

    <!-- Flower -->
    <svg v-else-if="type === 'flower'" :width="size" :height="size" viewBox="0 0 28 28" fill="none">
      <circle cx="14" cy="14" r="2.2" stroke="currentColor" stroke-width="1.3" />
      <ellipse cx="14" cy="7.5" rx="2.4" ry="3.6" stroke="currentColor" stroke-width="1.2" />
      <ellipse cx="14" cy="20.5" rx="2.4" ry="3.6" stroke="currentColor" stroke-width="1.2" />
      <ellipse cx="7.5" cy="14" rx="3.6" ry="2.4" stroke="currentColor" stroke-width="1.2" />
      <ellipse cx="20.5" cy="14" rx="3.6" ry="2.4" stroke="currentColor" stroke-width="1.2" />
    </svg>

    <!-- Cloud -->
    <svg v-else-if="type === 'cloud'" :width="size * 1.4" :height="size" viewBox="0 0 40 24" fill="none">
      <path
        d="M10 18h20a6 6 0 00.2-12 8 8 0 00-15.2 2.2A5.5 5.5 0 0010 18z"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Curved arrow pointing down-right -->
    <svg v-else-if="type === 'arrow'" :width="size * 1.6" :height="size" viewBox="0 0 64 36" fill="none">
      <path
        d="M4 8c12 2 22 18 40 20"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        fill="none"
      />
      <path d="M36 20l8 8 6-10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Arrow up-right -->
    <svg v-else-if="type === 'arrow-ur'" :width="size" :height="size" viewBox="0 0 28 28" fill="none">
      <path d="M6 22C10 12 16 8 22 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
      <path d="M14 6h8v8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Computer / laptop doodle -->
    <svg v-else-if="type === 'computer'" :width="size * 1.3" :height="size" viewBox="0 0 40 28" fill="none">
      <rect x="6" y="4" width="28" height="16" rx="1.5" stroke="currentColor" stroke-width="1.3" />
      <path d="M2 22h36" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M14 12h12M14 8h8" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" opacity="0.7" />
    </svg>

    <!-- Code brackets -->
    <svg v-else-if="type === 'code'" :width="size * 1.2" :height="size" viewBox="0 0 36 28" fill="none">
      <path d="M12 6L6 14l6 8M24 6l6 8-6 8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Scribble circle -->
    <svg v-else-if="type === 'scribble'" :width="size" :height="size" viewBox="0 0 40 40" fill="none">
      <path
        d="M20 6c8 0 14 5 14 12s-5 13-13 14c-9 1-15-5-15-12 0-8 6-14 14-14 3 0 6 1 8 3"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
        fill="none"
      />
    </svg>

    <!-- Dot cluster -->
    <svg v-else-if="type === 'dots'" :width="size" :height="size * 0.7" viewBox="0 0 36 20" fill="currentColor">
      <circle cx="4" cy="10" r="1.6" />
      <circle cx="14" cy="6" r="1.2" opacity="0.7" />
      <circle cx="22" cy="14" r="1.5" opacity="0.85" />
      <circle cx="32" cy="8" r="1.1" opacity="0.6" />
    </svg>

    <!-- Squiggle line -->
    <svg v-else-if="type === 'squiggle'" :width="size * 2" :height="14" viewBox="0 0 80 14" fill="none">
      <path
        d="M2 8C10 3 16 11 24 7s14-6 22-1 14 6 22 1 10-5 16-2"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: "SketchDoodle",
  props: {
    type: {
      type: String,
      default: "star",
    },
    size: {
      type: Number,
      default: 24,
    },
    top: String,
    left: String,
    right: String,
    bottom: String,
    rotate: {
      type: [Number, String],
      default: 0,
    },
    opacity: {
      type: [Number, String],
      default: null,
    },
    motion: {
      type: String,
      default: "", // float | drift | wiggle | arrow
    },
    hideOnMobile: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    motionClass() {
      const map = {
        float: "animate-float",
        drift: "animate-drift",
        wiggle: "animate-wiggle",
        arrow: "animate-arrow",
      };
      return map[this.motion] || "";
    },
    positionStyle() {
      const style = {};
      if (!this.inline) {
        if (this.top != null) style.top = this.top;
        if (this.left != null) style.left = this.left;
        if (this.right != null) style.right = this.right;
        if (this.bottom != null) style.bottom = this.bottom;
      }
      if (this.rotate) style.transform = `rotate(${this.rotate}deg)`;
      if (this.opacity != null) style.opacity = this.opacity;
      return style;
    },
  },
};
</script>
